module.exports = __webpack_public_path__ + "static/printex-splash-5cd606037297eeb0a4bec4afc02d1ced.jpg";